import { render, staticRenderFns } from "./ProvidersTrustNote.vue?vue&type=template&id=46345932&scoped=true&"
import script from "./ProvidersTrustNote.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProvidersTrustNote.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProvidersTrustNote.vue?vue&type=style&index=0&id=46345932&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46345932",
  null
  
)

export default component.exports